<template>
    <transition :name="name" :mode="mode" :duration="duration">
        <slot></slot>
    </transition>
</template>

<script>
    export default {
        name: 'component-switcher',
        props: {
            duration: {
                type: Number,
                default: 200
            },
            mode: {
                type: String,
                default: 'out-in'
            },
            name: {
                type: String,
                default: 'fade'
            },

        }
    }
</script>


<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

</style>
